import React, { Component } from 'react';
import { withRouter } from 'react-router';

import MessaggioChiusura from '../../../shared/MessaggioChiusura/MessaggioChiusura';

import { jsx, css } from '@emotion/core';

import './CheckoutProgress.scss';

class CheckoutProgress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      classAccedi: '',
      classRicetta: '',
      classSpedizione: '',
      classPagamento: '',
      classEsito: '',
    };
  }

  componentWillMount() {
    const prescription = this.props.cart.find(product => !!product.prescription);
    if (!!prescription) {
      this.setState({
        withRicetta: true,
      });
    }

    this.setProgressClasses(this.props.location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    this.setProgressClasses(nextProps.location.pathname);
  }

  setProgressClasses(pathname) {
    switch (pathname) {
      case '/accedi':
        this.setState({
          classAccedi: 'active',
          classRicetta: '',
          classSpedizione: '',
          classPagamento: '',
          classEsito: '',
        });
        break;
      case '/ricetta':
        this.setState({
          classAccedi: 'done',
          classRicetta: 'active',
          classSpedizione: '',
          classPagamento: '',
          classEsito: '',
        });
        break;
      case '/spedizione':
        this.setState({
          classAccedi: 'done',
          classRicetta: 'done',
          classSpedizione: 'active',
          classPagamento: '',
          classEsito: '',
        });
        break;
      case '/pagamento':
        this.setState({
          classAccedi: 'done',
          classRicetta: 'done',
          classSpedizione: 'done',
          classPagamento: 'active',
          classEsito: '',
        });
        break;
      case '/checkout-success':
      case '/checkout-failure':
        this.setState({
          classAccedi: 'done',
          classRicetta: 'done',
          classSpedizione: 'done',
          classPagamento: 'done',
          classEsito: 'active',
        });
        break;
      default:
        this.setState({
          classAccedi: '',
          classRicetta: '',
          classSpedizione: '',
          classPagamento: '',
          classEsito: '',
        });
    }
  }

  render() {
    const { primaryColor } = this.props;

    const checkoutProgressStyle = css`
      li {
        &.active {
          color: ${primaryColor};
        }

        &:not(:last-child):after {
          background-color: ${primaryColor};
        }
      }
    `
    return (
      <div className="checkout-progress" css={checkoutProgressStyle}>
        <ul className="list-inline">
          <li className={this.state.classAccedi}>
            <span className="hidden-sm">1. </span>Accedi
          </li>
          {this.state.withRicetta && (
            <li className={this.state.classRicetta}>
              <span className="hidden-sm">2. </span>Ricetta
            </li>
          )}
          <li className={this.state.classSpedizione}>
            <span className="hidden-sm">
              {this.state.withRicetta ? '3. ' : '2. '}
            </span>
            Spedizione
          </li>
          <li className={this.state.classPagamento}>
            <span className="hidden-sm">
              {this.state.withRicetta ? '4. ' : '3. '}
            </span>
            Pagamento
          </li>
          <li className={this.state.classEsito}>
            <span className="hidden-sm">
              {this.state.withRicetta ? '5. ' : '4. '}
            </span>
            Esito
          </li>
        </ul>

        <div style={{ marginTop: 30 }}>
          <MessaggioChiusura type="checkout" />
        </div>
      </div>
    );
  }
}

export default withRouter(CheckoutProgress);
